var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[(_vm.user.avatar)?_c('div',{staticClass:"wrapper",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.user.avatar}})]):_vm._e(),(_vm.user.nickname)?_c('div',{staticClass:"nickname",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.user.nickname))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }